module.exports = __webpack_public_path__ + "img/missed.e5d87379.svg";